import { ReturnsProduct } from '@api/returns/types'
import {
  ColorStep,
  SizesStep,
  ReasonStep,
  AdditionalFieldsStep
} from './ExchangeSteps'
import { RETURN_REASON_CODES } from '@components/returns/consts'
import { ReasonStepProps } from './ExchangeSteps/ReasonStep'
import { SizesStepProps } from './ExchangeSteps/SizesStep'
import { ColorStepProps } from './ExchangeSteps/ColorStep'

type UseExchangeStepsProps = {
  reason: number | undefined
  colors: Partial<ReturnsProduct['exchange_colors']>
  showAdditionalFields: boolean
}

type Step = {
  order: number
  step: React.ComponentType<ReasonStepProps & SizesStepProps & ColorStepProps>
  show: boolean
}

export default function useExchangeSteps({
  reason,
  colors,
  showAdditionalFields
}: UseExchangeStepsProps) {
  const hasColorsAvailable = !!colors?.length
  const colorAnswerSelected =
    hasColorsAvailable && RETURN_REASON_CODES.COLOR === reason
  const stepsList: Step[] = [
    {
      step: ReasonStep,
      order: 1,
      show: true
    },
    {
      step: AdditionalFieldsStep,
      order: 2,
      show: showAdditionalFields
    },
    {
      step: ColorStep,
      order: colorAnswerSelected ? 3 : 4,
      show: hasColorsAvailable
    },
    {
      step: SizesStep,
      order: colorAnswerSelected ? 4 : 3,
      show: true
    }
  ]

  const orderedSteps = stepsList
    .sort((a: Step, b: Step) => a.order - b.order)
    .filter((item: Step) => item.show === true)
    .map((item: Step) => item.step)

  return orderedSteps
}
